import { Navigate, useLocation } from 'react-router';
import { useAuthStore } from '../../stores/authStore';

type AuthGuardProps = {
  children: React.ReactNode;
};

/**
 * Wraps protected routes. Redirects to /login if not authenticated.
 * Waits for initAuth() to complete before making the decision.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isInitializing = useAuthStore((s) => s.isInitializing);
  const location = useLocation();

  // Wait for the token refresh attempt before redirecting
  if (isInitializing) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
